import { object, string } from 'yup';
import { ILoginPageViewModel } from '../../../../login/@data/store/schema/ILoginPageViewModel';

export function loginPageErrorModel() {
  return object<ILoginPageViewModel>().shape({
    email: string().trim().email('Please enter a valid email address.').required('Please enter your email address.'),
  });
}
